// extracted by mini-css-extract-plugin
module.exports = {"rcTable":"style__rcTable__27DlW"};